import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FadeIn from './FadeIn';

const SCHEDULE_EXAMPLES = [
  {
    input: 'Every Friday from 4 PM until 8 PM',
    chips: ['Fridays', '4:00 PM – 8:00 PM', 'Repeating weekly'],
  },
  {
    input: 'Only weekends',
    chips: ['Saturday', 'Sunday', 'All day'],
  },
  {
    input: 'Immediately',
    chips: ['Live now', 'All screens'],
  },
];

export default function SchedulerDemo({ className = '' }) {
  const [index, setIndex] = useState(0);
  const [typed, setTyped] = useState('');
  const [showChips, setShowChips] = useState(false);

  const current = SCHEDULE_EXAMPLES[index];

  useEffect(() => {
    setTyped('');
    setShowChips(false);
    let i = 0;
    const interval = setInterval(() => {
      if (i < current.input.length) {
        setTyped(current.input.slice(0, i + 1));
        i += 1;
      } else {
        clearInterval(interval);
        setTimeout(() => setShowChips(true), 500);
        setTimeout(() => {
          setShowChips(false);
          setIndex((prev) => (prev + 1) % SCHEDULE_EXAMPLES.length);
        }, 3000);
      }
    }, 40);
    return () => clearInterval(interval);
  }, [index, current.input]);

  return (
    <FadeIn className={className}>
      <div className="max-w-xl mx-auto">
        <div className="rounded-2xl border border-invert-border bg-white p-6 shadow-lg">
          <p className="text-sm text-slate-500 mb-3">When should this run?</p>
          <div className="flex items-center gap-2 bg-slate-50 rounded-xl px-4 py-3 mb-4">
            <span className="text-invert-navy font-medium flex-1">
              {typed}
              <span className="animate-blink text-invert-orange">|</span>
            </span>
          </div>
          <AnimatePresence>
            {showChips && (
              <motion.div
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                className="flex flex-wrap gap-2"
              >
                {current.chips.map((chip) => (
                  <span
                    key={chip}
                    className="px-3 py-1.5 bg-invert-orange/10 text-invert-orange text-sm font-medium rounded-full"
                  >
                    {chip}
                  </span>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </FadeIn>
  );
}
